import MainLayout from "@/Layouts/MainLayout";
import {autoAnimatePlugin} from "@formkit/auto-animate/vue";
import "vue-select/dist/vue-select.css";
import {createApp, h, computed} from "vue";
import {createInertiaApp, usePage} from "@inertiajs/inertia-vue3";
import {InertiaProgress} from "@inertiajs/progress";
import "./fontawesome.js";
import {Inertia} from "@inertiajs/inertia";
import VueGtagPlugin, {useGtag, useState} from "vue-gtag-next";

require("./bootstrap");

const appName = window.document.querySelector("meta[name=app-name]").content || "Laravel";

// Always make scroll go to top of page
Inertia.resetScrollPositions = (function () {
    document.documentElement.scrollTo(0, 0);

    this.scrollRegions().forEach(region => {
        region.scrollTo(0, 0);
    });
    this.saveScrollPositions();
    if (window.location.hash) {
        document.getElementById(window.location.hash.slice(1))?.scrollIntoView();
    }
}).bind(Inertia);

if(window.document.querySelector("meta[name=performance-cookies-allowed]")) {
    Inertia.on("start", event => {
        const {pageview} = useGtag();

        pageview({
            page_path: event.detail.visit.url.pathname
        });
    }).bind(Inertia);
}

createInertiaApp({
    title: (title) => title ? `${title} | ${appName}` : "Tyre Seeker | Tyre Reviews | Tyre Tests & Ratings",
    // resolve: (name) => require(`./Pages/${name}.vue`),
    // Add the MainLayout to every page that isn't in the admin area
    resolve: name => {
        const page = require(`./Pages/${name}`).default;

        if (page.layout === undefined && !name.startsWith("Admin/")) {
            page.layout = MainLayout;
        }

        return page;
    },
    setup({el, app, props, plugin}) {
        const Vue = createApp({render: () => h(app, props)})
            .use(plugin)
            .mixin({methods: {route}});

        Vue.use(VueGtagPlugin);
        Vue.config.globalProperties.$trusted_checks = computed(() => usePage().props.value.config.trusted_checks);
        Vue.config.globalProperties.$site_name = computed(() => usePage().props.value.config.name);

        const {query} = useGtag();

        if(window.document.querySelector("meta[name=advertising-cookies-allowed]")) {
            query('consent', 'default', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted'
            });
        }
        else {
            query('consent', 'default', {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
            });
        }

        if(window.document.querySelector("meta[name=performance-cookies-allowed]")) {
            query('consent', 'default', {
                'analytics_storage': 'granted',
            });
        }
        else {
            query('consent', 'default', {
                'analytics_storage': 'denied',
            });
        }

        const { property } = useState();

        property.value = {
            id: 'G-39F3E04WHB',
            params: {
                send_page_view: true
            }
        }

        Vue.use(autoAnimatePlugin);

        Vue.config.unwrapInjectedRef = true;

        Vue.mount(el);
    },

});

InertiaProgress.init({color: "#4B5563", showSpinner: true});
